import { MenuItem } from '@/core/models';
import { BaseModifierPriceCalculationStrategy } from './base-modifier-price-calculation.strategy';

export abstract class BasePriceCalculationStrategy {
	constructor(protected readonly modifierItemStrategy: BaseModifierPriceCalculationStrategy) {}

	public calculationTotal(menuItem: MenuItem): bigint {
		return this.extractFactorPrice(menuItem);
	}

	protected abstract extractFactorPrice(menuItem: MenuItem): bigint;
}
